import React from 'react';
import { ManagedRuntime } from 'effect';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';

import App from './App';
import { ServiceLayer } from 'services/layer';
import SWWPage from 'initializers/envs/SWW';
import reportWebVitals from './reportWebVitals';
import { Authenticator } from '@aws-amplify/ui-react';
import { LocaleProvider } from 'contexts/localeContext';
import { ToastProvider } from 'contexts/toastContext';
import { LabelOptionsProvider } from 'contexts/labelOptionsContext';
import { AuthContextProvider } from 'contexts/authContext';
import CrashPage from 'components/CrashPage';
import sentryInitializer from 'initializers/sentry';
import envsInitializer from 'initializers/envs';
import { EffectRuntimeProvider } from './effect/runtimeProvider';

import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

sentryInitializer();
envsInitializer()
  .then(() => {
    root.render(
      <Authenticator.Provider>
        <EffectRuntimeProvider runtime={ManagedRuntime.make(ServiceLayer)}>
          <LabelOptionsProvider>
            <LocaleProvider>
              <ToastProvider>
                <AuthContextProvider>
                  <Sentry.ErrorBoundary fallback={<CrashPage />}>
                    <App />
                  </Sentry.ErrorBoundary>
                </AuthContextProvider>
              </ToastProvider>
            </LocaleProvider>
          </LabelOptionsProvider>
        </EffectRuntimeProvider>
      </Authenticator.Provider>,
    );
  })
  .catch((err) => {
    root.render(<SWWPage />);
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
